import { injectable } from 'inversify';
import { RegionService } from '../state/reduxRepositories/region/region.service';
import { useAppSelector } from '../state/hooks';
import {
  Region,
  CurrentRegion,
} from '../state/reduxRepositories/region/region.interface';
import { RegionType } from '../state/reduxRepositories/region/region.enum';

@injectable()
export class RegionDomain {
  public constructor(private readonly regionService: RegionService) {}

  dispatchRegion = () => {
    this.regionService.dispatchRegion();
  };

  dispatchDialog = (value: boolean) => {
    this.regionService.dispatchDialog(value);
  };

  useLoadDialogSelector = () => {
    return useAppSelector(this.regionService.useShowDialogSelector);
  };

  useRegionSelector = (): CurrentRegion => {
    return useAppSelector(this.regionService.useRegionSelector);
  };

  useSiteRegion = () => {
    return this.regionService.siteRegion();
  };

  useSupportedRegions = (): Region[] => {
    return this.regionService.supportedLocalRegions();
  };

  useIsSupportedRegion = (currentRegion: Region) => {
    const supportedRegion = this.useSupportedRegions();
    return supportedRegion.includes(currentRegion.toUpperCase());
  };

  useLocalRegion = (region: string) => {
    return this.regionService.localRegion(region);
  };

  useIsRegionMatching = () => {
    return this.regionService.isRegionMatching(
      this.useRegionSelector()?.country,
    );
  };
}
